import { useFetchBalance, useFetchTransactions } from './walletQueries'

export const usePreloadWallet = (kycComplete: boolean) => {
    useFetchBalance({ enabled: kycComplete })
    useFetchTransactions({ enabled: kycComplete })
}
